import bind from 'memoize-bind'
import detectMobileBrowser from '@/utils/detectMobileBrowser'

export default {
    data() {
        return {
            isMobile: false
        }
    },

    created() {
        window.addEventListener('resize', bind(this.recheckMobile, this))
    },

    beforeDestroy() {
        window.removeEventListener('resize', bind(this.recheckMobile, this))
    },

    methods: {
        recheckMobile() {
            this.isMobile = detectMobileBrowser('all') != null || window.innerWidth <= 1030;
        }
    }
}